import React from "react";
import { Link } from "gatsby";
import { ArrowRight } from "lucide-react";
import { siteHref } from "../helpers/siteUrls";

// A town's other service pages, linked from its roofing page. Before this, the
// siding, window and door pages of most towns had about one internal link each
// (SEO fixes sheet, 2026-11-02). The link text names the service and the town,
// so each link also tells search engines what the page is about.
const OTHER_SERVICES = [
  { slug: "siding-contractor", label: (town) => `Siding contractor in ${town}` },
  { slug: "window-replacement-contractor", label: (town) => `Window replacement in ${town}` },
  { slug: "exterior-door-installers", label: (town) => `Exterior door installation in ${town}` },
];

const CityOtherServices = ({ city, cities }) => {
  const cityName = String(city).trim();
  const key = cityName.toLowerCase();
  // The town's slug comes from the Contentful list, like the nearby-areas
  // links in city-neighborhoods.js: some end in "-mi", some do not.
  const town = (cities || [])
    .map((edge) => edge && edge.node)
    .find((node) => node && node.slug && String(node.location).trim().toLowerCase() === key);

  if (!town) return null;

  return (
    <section
      className="not-prose mt-12 rounded-2xl border border-neutral-200 bg-neutral-50 p-6 md:p-8"
      aria-labelledby="other-services-heading"
    >
      <h2
        id="other-services-heading"
        className="text-xl md:text-2xl font-display font-extrabold text-neutral-900 leading-tight"
      >
        Other Services in {cityName}
      </h2>
      <ul className="list-none p-0 m-0 mt-5 grid gap-3">
        {OTHER_SERVICES.map(({ slug, label }) => (
          <li key={slug}>
            <Link
              to={siteHref(`/${slug}-${town.slug.trim()}/`)}
              className="flex items-center justify-between gap-3 h-full rounded-xl bg-white px-4 py-3 font-semibold leading-snug text-neutral-900 shadow-sm ring-1 ring-neutral-200 hover:ring-brand-500 hover:text-brand-700 transition"
            >
              <span>{label(cityName)}</span>
              <ArrowRight size={16} aria-hidden="true" className="shrink-0 text-brand-600" />
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default CityOtherServices;
